export default __webpack_public_path__ + "static/media/comments.d243a37b.png";